import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavigationDrawer from "../../../components/NavigationDrawer";
import appcolors from "../../../constants/Colors";

function CreatorOnboarding() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userData.user);

  const isRejected = userData?.status === "rejected";
  const rejectionReason =
    userData?.rejectionReason || userData?.rejectReason || userData?.reason;

  return (
    <NavigationDrawer>
      <Stack alignItems="center" justifyContent="center" minHeight="70vh">
        <Box
          sx={{
            maxWidth: 560,
            width: "100%",
            p: { xs: 3, md: 5 },
            borderRadius: "16px",
            backgroundColor: "#fff",
            border: `1px solid ${isRejected ? "#FFC9C9" : "#E9DBFF"}`,
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              mx: "auto",
              mb: 2,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "2rem",
              backgroundColor: isRejected ? "#FFF0F0" : "#F3EBFF",
            }}
          >
            {isRejected ? "✕" : "⏳"}
          </Box>

          <Typography
            variant="h3"
            fontSize={"1.375rem"}
            fontWeight={700}
            color={isRejected ? "#E03131" : appcolors.gunmetal}
          >
            {t(isRejected ? "accountRejectedTitle" : "accountInReviewTitle")}
          </Typography>

          <Typography
            mt={1.5}
            fontSize={"0.938rem"}
            color={"#868E96"}
            lineHeight={1.6}
          >
            {t(isRejected ? "accountRejectedDesc" : "accountInReviewDesc")}
          </Typography>

          {isRejected && rejectionReason ? (
            <Typography
              mt={2}
              fontSize={"0.875rem"}
              color={appcolors.gunmetal}
              sx={{ backgroundColor: "#FFF5F5", p: 1.5, borderRadius: "8px" }}
            >
              <b>{t("rejectionReason")}:</b> {rejectionReason}
            </Typography>
          ) : null}

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            justifyContent="center"
            mt={3}
          >
            <Button
              variant="contained"
              disableElevation
              onClick={() => navigate("/creator/customer-support")}
              sx={{ textTransform: "none", borderRadius: "8px" }}
            >
              {t("contactSupport")}
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate("/creator/settings")}
              sx={{ textTransform: "none", borderRadius: "8px" }}
            >
              {t("goToSettings")}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </NavigationDrawer>
  );
}

export default CreatorOnboarding;
